<script setup lang="ts">
import type { NuxtError } from '#app';
import errorImage from "~/assets/images/error.png";
import UiPicture from "~/components/ui/UiPicture/UiPicture.vue";


import { computed } from 'vue';

const props = defineProps({
    error: {
        type: Object as () => NuxtError,
        required: true,
    },
});

const showStatusCode = computed(() => {
    return props.error.status !== 404;
});

const errorTitle = computed(() => {
    return props.error.status === 404
        ? 'Страница не найдена'
        : 'Something went wrong';
});

const errorDescription = computed(() => {
    return props.error.status === 404
        ? 'К сожалению, запрашиваемая вами страница была удалена, перемещена или никогда не существовала. Пожалуйста, проверьте правильность ссылки или вернитесь на главную.'
        : 'Please try again later.';
});

const handleBackToHomeClick = () => {
    clearError();
};
</script>

<template>
    <NuxtLayout name="error">
        <section class="error-page">
            <div class="error-page__content">
                <span v-if="showStatusCode" class="error-page__code">{{ error.status }}</span>
                <h1 class="error-page__title">{{ errorTitle }}</h1>

                <p class="error-page__text">{{ errorDescription }}</p>

                <NuxtLink
                    to="/"
                    class="error-page__link"
                    @click="handleBackToHomeClick"
                >
                    Вернуться на главную
                </NuxtLink>
            </div>
            <UiPicture
                :src="errorImage"
                title="error"
                class="error-page__picture"
            />
        </section>
    </NuxtLayout>
</template>

<style scoped lang="scss">
@import "assets/styles/scss/components/_error.scss";
</style>
